export const twoDecimalPlaces = /^[0-9]+(\.[0-9]{1,2})?$/i

export const noDecimal = /^\d*$/i

export const twoDecimalPlacesOptional = (value) => {
  if (!value) return true
  return !!value.match(twoDecimalPlaces)
}
